import axios from "axios";

export type MaintenanceApi = {
    /** Starts the backfill and resolves to the Asio job session id to watch. */
    backfillResponsibilityRoles(): Promise<string>;
    /** Starts the cleanup and resolves to the Asio job session id to watch. */
    cleanupEmptyChangeLogs(): Promise<string>;
};

export const maintenanceApi: MaintenanceApi = {
    async backfillResponsibilityRoles() {
        const { data } = await axios.post<{ sessionId: string }>(
            "/api/v0/admin/maintenance/responsibility-roles/backfill"
        );

        return data.sessionId;
    },
    async cleanupEmptyChangeLogs() {
        const { data } = await axios.post<{ sessionId: string }>(
            "/api/v0/admin/maintenance/empty-change-logs/cleanup"
        );

        return data.sessionId;
    },
};
